<template>
    <main id="bilan">
        <div id="blured-decor">
            <img
                v-if="decor"
                :src="'images/bilan/' + decor"
                alt="Decor Image"
            />
        </div>
  
        <!-- Le décor et les éléments de la scène -->
        <div id="decor-elements">
            <!-- étoile component -->
            <etoile-component
                :score_etoile="Number(score_etoile)" />

            <!-- Codex component -->
            <list-codex-component
                :list_codex="list_codex" />
  
            <!-- Décor -->
            <img 
                id="decor"
                :src="'images/bilan/' + decor"
                v-if="decor"
            />
  
            <!-- Données du bilan -->
            <div id="container-bilan">
                <div class="row h-100 d-flex justify-content-between flex-column m-auto flex-nowrap">
                    <!-- Texte bilan -->
                    <div class="col-12 position-relative d-flex align-items-start justify-content-center" id="col-bilan">
                        <div
                            v-if="bilan"
                            id="bilan-interlocuteur"
                            class="text-start bottom-0"
                        >
                            <!-- Titre du bilan -->
                            <div
                                v-if="bilan?.titre"
                                id="titre-bilan"
                                v-html="bilan.titre"
                            ></div>
                            <!-- Description du bilan -->
                            <div 
                                v-if="bilan?.description"
                                id="bilan-description"
                                class="show-text-slow"
                                v-html="bilan.description"
                            ></div>
                        </div>
                    </div>
                    <!-- Réponses joueur -->
                    <div class="col-12 position-relative flex-column" id="col-reponses">
                        <div id="col-reponses-consigne" class="padding-bottom">
                            <!-- List réponses -->
                            <div id="row-reponse">
                                <form :class="'form-reponse'">
                                    <!-- CSRF Token (injecté dynamiquement) -->
                                    <input
                                        type="hidden"
                                        :name="csrfTokenName"
                                        :value="csrfTokenValue"
                                    />
                                    <!-- Bouton Rejouer -->
                                    <button
                                        id="button-rejouer"
                                        class="reponse w-100"
                                        type="button"
                                        @click="click_rejouer"
                                    >
                                        Rejouer
                                    </button>
                                </form>
                            </div>
                            <div class="d-flex">
                                <div id="logo-client">
                                    <img src="images/accueil/logo.svg" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
  
<script>
    /* eslint-disable */ 
    import router from '../router'
    import EtoileComponent from './EtoileComponent.vue';
    import ListCodexComponent from './ListCodexComponent.vue';

    export default {
        name: "BilanComponent",
        components: {
            EtoileComponent,
            ListCodexComponent
        },
        props:{
            csrfTokenName: {
                type: String,
                default: null
            },
            csrfTokenValue: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                titre: "",
                decor: "",
                bilan: {},
                list_codex: {},
                score_etoile: '1',
            };
        },

        mounted() {
            this.animation_show_text_slow();
        },
        watch: {
            bilan() {
                this.animation_show_text_slow();
            },
        },
        methods: {
            // Lance l'animation show_text_slow lors d'un changement de l'état du dialogue
            animation_show_text_slow() {
                // Get and hide the texts immediatly
                let $texts = $('.show-text-slow');
                $texts.css('opacity', '0');

                // When dom ready
                $( function() {
                    let totalDelay = show_text_slow();
                })  
            },
            click_rejouer() {
                // Logique de redémarrage du jeu
                this.rejouer();
            },
            // Fonction pour relancer le jeu
            async rejouer() {
                try {
                    const response = await fetch('/restart', {
                        method: 'GET',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest', // Indique que c'est une requête AJAX
                            'Content-Type' : 'application/json'
                        }
                    });

                    // Vérification si la réponse est réussie
                    if ( response.ok ) { 
                        const retour = await response.json();  // Attendre la reponse en JSON
                        // If success on redirige sur la page jeu
                        if( retour.status == 'success' )
                            router.push( '/jeu' );
                        else {
                            throw new Error( "Une erreur inconnue est survenu." );
                        }
                    } else {
                        // Gestion des erreurs
                        const err = await response.json();  // Attendre la conversion en JSON
                        throw new Error( err.message );  // Stopper le traitement
                    }
                } catch ( error ) {
                    console.error( 'Erreur lors du redémarrage du jeu:', error );
                }
            }
        },
        // Vérifie les droits d'accès à la route et récupère les données
        beforeRouteEnter(to, from, next) {
            // Fetch bilan controller
            fetch("/bilan", {
                method: "GET",
                headers: {
                    "X-Requested-With": "XMLHttpRequest", // Nécessaire pour le backend pour reconnaître la requête ajax
                },
            })
            // Vérifie la réponse du serveur
            .then(async (response) => {
                if (response.status == 200) {
                    return response.json();
                } else {
                    // Retourne le message d'erreur JSON
                  const err=await response.json();
                  throw new Error(err.message); // Stoppe le traitement
                }
            })
            // Parse les données
            .then(( data ) => {
                // Transfère les données au composant
                next(( component ) => {
                    Object.assign( component.$data, data );
                });
            })
            .catch(( error ) => {
                console.error( "Error fetching Bilan data:", error );
                next( false ); // Empêche la navigation en cas d'erreur
            });
        },
    };
</script>